import { render, staticRenderFns } from "./AccessInvitationForm.vue?vue&type=template&id=7529a338&"
import script from "./AccessInvitationForm.vue?vue&type=script&lang=js&"
export * from "./AccessInvitationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7529a338')) {
      api.createRecord('7529a338', component.options)
    } else {
      api.reload('7529a338', component.options)
    }
    module.hot.accept("./AccessInvitationForm.vue?vue&type=template&id=7529a338&", function () {
      api.rerender('7529a338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/Access/Approved/AccessInvitationForm.vue"
export default component.exports